/* eslint-disable camelcase */
import sharedConstants from "@lib/shared_constants";
const TAG_SELECTOR = sharedConstants.ENGAGEMENT_REPORT.TAG_SELECTORS;

export type EngagementReportCampaign = {
  campaign_name: string;
  id: string;
  messaging_actions: {
    message_type: string;
  }[];
  created: {
    time: number;
  };
  campaign_type: string;
  is_archived: boolean;
};

export type EngagementReportCanvas = {
  workflow_name: string;
  id: string;
  steps: {
    messaging_actions: {
      message_type: string;
    }[];
  }[];
  created: {
    time: number;
  };
  is_archived: boolean;
};

export type TagSelectorType = (typeof TAG_SELECTOR)[keyof typeof TAG_SELECTOR];
export interface EngagementReportScheduleData {
  start_date_time: number;
  deliver_in_local_time: boolean;
  optimal_time_notification: boolean;
  use_app_group_best_time: boolean;
  optimal_time_default_hour: number;
  optimal_time_default_minute: number;
  quiet_start_hour: number;
  quiet_start_minute: number;
  quiet_end_hour: number;
  quiet_end_minute: number;
  has_quiet_time: boolean;
  frequency: string;
  repeat_interval: number;
  end_occurrences_count: number;
  content_card_delivery_control: string;
  display_text: string;
  next_occurrence: number;
  last_occurrence: number;
  recurring: boolean;
  weekdays:
    | {
        sunday?: boolean;
        monday?: boolean;
        tuesday?: boolean;
        wednesday?: boolean;
        thursday?: boolean;
        friday?: boolean;
        saturday?: boolean;
      }
    | undefined;
}
export interface EngagementReportData {
  id: string;
  name: string;
  compression: string;
  delimiter: string;
  selected_kpis_as_json: string[];
  email_to: string[];
  has_completed_wizard: boolean;
  num_days_to_aggregate: number;
  num_days_for_rolling_window: number;
  aggregate_by_entire_message: boolean;
  use_rolling_window: boolean;
  tag_selected: boolean;
  selected_tags: string[];
  selected_tag_selector: TagSelectorType;
  start_date: number;
  end_date: number;
  send_immediately: boolean;
  tag_names: string[];
  exclude_archived: boolean;
  marked_as_deleted: boolean;
  schedule_data: EngagementReportScheduleData;
  selected_campaigns: EngagementReportCampaign[];
  selected_workflows: EngagementReportCanvas[];
}
